export type TutorialAudience = 'all' | 'admin' | 'supervisor' | 'employee' | 'client';

export interface TutorialVideo {
  id: string;
  src: string;
  /** Público-alvo principal (para badge na UI). */
  audience: TutorialAudience;
  titleKey: 'helpVideoOverview' | 'helpVideoAdminFull' | 'helpVideoEmployee' | 'helpVideoClient';
  descriptionKey:
    | 'helpVideoOverviewDesc'
    | 'helpVideoAdminFullDesc'
    | 'helpVideoEmployeeDesc'
    | 'helpVideoClientDesc';
  audienceLabelKey: 'helpAudienceAll' | 'helpAudienceAdmin' | 'helpAudienceEmployee' | 'helpAudienceClient';
  durationMinutes: number;
}

export const TUTORIAL_VIDEOS: TutorialVideo[] = [
  {
    id: 'overview',
    src: '/tutorials/overview.mp4',
    audience: 'all',
    titleKey: 'helpVideoOverview',
    descriptionKey: 'helpVideoOverviewDesc',
    audienceLabelKey: 'helpAudienceAll',
    durationMinutes: 2,
  },
  {
    id: 'admin-full',
    src: '/tutorials/admin-full.mp4',
    audience: 'admin',
    titleKey: 'helpVideoAdminFull',
    descriptionKey: 'helpVideoAdminFullDesc',
    audienceLabelKey: 'helpAudienceAdmin',
    durationMinutes: 4,
  },
  {
    id: 'employee',
    src: '/tutorials/employee.mp4',
    audience: 'employee',
    titleKey: 'helpVideoEmployee',
    descriptionKey: 'helpVideoEmployeeDesc',
    audienceLabelKey: 'helpAudienceEmployee',
    durationMinutes: 2,
  },
  {
    id: 'client',
    src: '/tutorials/client.mp4',
    audience: 'client',
    titleKey: 'helpVideoClient',
    descriptionKey: 'helpVideoClientDesc',
    audienceLabelKey: 'helpAudienceClient',
    durationMinutes: 2,
  },
];

/** Todos os tutoriais ficam visíveis na Central de Ajuda. */
export function getAllTutorialVideos(): TutorialVideo[] {
  return TUTORIAL_VIDEOS;
}

/** Destaca o vídeo mais relevante para o perfil (opcional). */
export function getDefaultVideoForRole(role?: string): TutorialVideo {
  if (role === 'supervisor') {
    return TUTORIAL_VIDEOS.find(v => v.id === 'admin-full') ?? TUTORIAL_VIDEOS[0];
  }
  const match = TUTORIAL_VIDEOS.find(v => v.audience === role);
  return match ?? TUTORIAL_VIDEOS[0];
}
